<template>
  <span
    class="rounded-full py-1 px-3 text-white"
    :class="[{ 'bg-green-400': value, 'bg-red-400': !value, 'text-xs': small }]">
    {{ value ? 'Ativo' : 'Inativo' }}
  </span>
</template>

<script setup>
const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  small: Boolean,
})
</script>
